import { render, staticRenderFns } from "./MultiformatCard.vue?vue&type=template&id=43acd887&scoped=true&"
import script from "./MultiformatCard.vue?vue&type=script&lang=js&"
export * from "./MultiformatCard.vue?vue&type=script&lang=js&"
import style0 from "./MultiformatCard.vue?vue&type=style&index=0&id=43acd887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acd887",
  null
  
)

export default component.exports